<template>
    <div class="task_box animate__animated animate__fadeIn">
        <div class="task">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">任务名称</div>
                        <input type="text" class="input_box" placeholder="请输入任务名称" v-model="searchName" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">任务内容</div>
                        <input type="text" class="input_box" placeholder="请输入任务内容" v-model="searchContent" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">任务状态</div>
                        <el-select size="small" v-model="searchState" :popper-append-to-body="false" filterable
                            placeholder="请选择">
                            <el-option value="">请选择</el-option>
                            <el-option label="待执行" value="0">待执行</el-option>
                            <el-option label="全部成功" value="1">全部成功</el-option>
                            <el-option label="部分成功" value="2">部分成功</el-option>
                            <el-option label="全部失败" value="3">全部失败</el-option>
                        </el-select>
                    </div>
                    <div class="search-btn" @click="fnSearch"><span>搜索</span></div>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">任务名称</div>
                    <div class="title_item">任务内容</div>
                    <div class="title_item">执行情况</div>
                    <div class="title_item">详情</div>
                    <div class="title_item">任务状态</div>
                    <div class="title_item">完成时间</div>
                    <div class="title_item">创建时间</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="CardData">
                            <div class="box_line" v-for="(item, index) in CardData" :key="index">
                                <div class="list_item">{{ item.name }}</div>
                                <div class="list_item">{{ item.content }}</div>
                                <div class="list_item">{{ item.execution }}</div>
                                <div class="list_item" :title="fnDetailsFormat(item.details)"
                                    @click="fnShowDetails(item.details)">
                                    <span>{{ fnDetailsFormat(item.details) }}</span>
                                </div>
                                <div class="list_item">
                                    <span v-if="item.state == 0" style="color: #409EFF">待执行</span>
                                    <span v-else-if="item.state == 1" style="color: #67c23a">全部成功</span>
                                    <span v-else-if="item.state == 2" style="color: #E6A23C">部分成功</span>
                                    <span v-else style="color: #F56C6C">全部失败</span>
                                </div>
                                <div class="list_item">{{ item.revise_at }}</div>
                                <div class="list_item">{{ item.create_at }}</div>
                                <div class="list_item">
                                    <div>
                                        <button class="item_btn" v-if="item.state > 1 && item.name=='下发人员至设备'"
                                            @click="fnShowDetails(item.details)"><span>重试</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cont_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-sizes="pageSizes" :page-size="pageSize" :current-page="currentPage"
                    layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" />
            </div>

            <div class="dialog_task" v-if="showTaskDetails">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" :title="taskDetails.title"
                    center :visible.sync="showTaskDetails">
                    <div class="tips">提示: 请确认重试下发人员错误情况已处理 !</div>
                    <div class="cont_list">
                        <div class="list_title">
                            <div class="title_item">
                                <div class="select" @click="fnSelectAll()" :class="selectAll ? 'active' : ''"></div>
                            </div>
                            <div class="title_item">姓名</div>
                            <div class="title_item">操作结果</div>
                            <div class="title_item">详情</div>
                        </div>
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="taskDetails.data">
                                    <div class="box_line" v-for="(item, index) in taskDetails.data" :key="index">
                                        <div class="list_item">
                                            <div class="select" @click="fnHandleCheckedChange(index)"
                                                :class="item.selected ? 'active' : ''"></div>
                                        </div>
                                        <div class="list_item">{{ item.name }}</div>
                                        <div class="list_item">
                                            <span v-if="item.state == 1" style="color: #67c23a">{{ item.text }}</span>
                                            <span v-else style="color: #F56C6C">{{ item.text }}</span>
                                        </div>
                                        <div class="list_item" :title="item.details">
                                            <span>{{ item.details }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn orange" @click="fnSendPerson" v-if="isError"><span>下发人员至人脸设备</span>
                            </div>
                            <div class="search-btn red" @click="showTaskDetails = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <!-- 选择人脸设备的弹出层 -->
            <div class="dialog_choose" v-if="showSelectFace">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" v-if="showSelectFace"
                    title="选择人脸设备" center :visible.sync="showSelectFace">
                    <div class="cont_list">
                        <div class="list_title">
                            <div class="title_item">
                                <div class="select" @click="fnSelectAllAccess()"
                                    :class="selectAllAccess ? 'active' : ''"></div>
                            </div>
                            <div class="title_item">设备名</div>
                            <div class="title_item">LANIP</div>
                            <div class="title_item">方向</div>
                            <div class="title_item">状态</div>
                        </div>
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="faceList">
                                    <div class="box_line" v-for="(item, index) in faceList" :key="index">
                                        <div class="list_item">
                                            <div class="select" @click="fnHandleCheckedAccessChange(index, item)"
                                                :class="item.selected ? 'active' : ''"></div>
                                        </div>
                                        <div class="list_item" :title="item.sn">{{ item.name }}</div>
                                        <div class="list_item">{{ item.lanIP }}</div>
                                        <div class="list_item">
                                            <span v-if="item.record_type == 0">无效</span>
                                            <span v-else-if="item.record_type == 1">进门</span>
                                            <span v-else>出门</span>
                                        </div>
                                        <div class="list_item">{{ fnOnlineStatusText(item.heartbeatTime).text }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer" align="center">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showSelectFace = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnSendPersonToAccess"><span>下发</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
    import request from '@/utils/request';
    import APP from '@/utils/base';
    import {
        setPageAuth,
        getUserInfo
    } from '@/utils/auth';
    export default {
        data() {
            return {
                selectAll: false, // 是否全选
                selectAllAccess: false, // 是否全选设备
                pageSize: APP.PAGE.LIMIT,
                pageSizes: APP.PAGE.SIZE_OPTION,
                currentPage: APP.PAGE.SKIP_PAGE,
                pageTotal: 0,
                userInfo: null, // 项目登录缓存信息
                searchName: '', // 搜索任务名称
                searchContent: '', // 搜索任务内容
                searchState: '', // 搜索任务状态
                selectedSendPersonnel: [], // 选择下发至人脸设备的人员
                faceList: [], // 人脸设备列表
                showSelectFace: false, // 选择人脸设备弹窗
                selectAccess: [], // 选中的设备
                eqptSN: '', // 设备号
                CardData: [], // 任务列表数据
                isError: false,
                showTaskDetails: false, // 任务详情弹窗
                taskDetails: {
                    // 任务详情弹出信息
                    title: '任务详情',
                    data: []
                }
            };
        },
        created() {
            this.userInfo = getUserInfo();
            this.fnGetData({
                page: this.currentPage,
                size: this.pageSize
            });
        },
        methods: {
            // 分页
            handleSizeChange(val) {
                this.pageSize = val;
                this.fnSearch(false);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.fnSearch(false);
            },
            // 获取设备数据
            fnGetData(_obj) {
                request({
                        url: 'task/get',
                        method: 'GET',
                        params: _obj
                    })
                    .then(res => {
                        this.CardData = res.data.query;
                        this.pageTotal = res.data.count;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 全选
            fnSelectAll() {
                this.selectAll = !this.selectAll;
                if (this.selectAll) {
                    for (let i = 0; i < this.taskDetails.data.length; i++) {
                        this.taskDetails.data[i].selected = true;
                    }
                    this.selectedSendPersonnel = this.taskDetails.data;
                } else {
                    for (let i = 0; i < this.taskDetails.data.length; i++) {
                        this.taskDetails.data[i].selected = false;
                        this.selectedSendPersonnel = [];
                    }
                }
            },
            // 单个选择
            fnHandleCheckedChange(_index) {
                for (let i = 0; i < this.taskDetails.data.length; i++) {
                    if (i == _index) {
                        this.taskDetails.data[i].selected = !this.taskDetails.data[i].selected;
                    }
                }
                let _arr = [];
                for (let j = 0; j < this.taskDetails.data.length; j++) {
                    if (this.taskDetails.data[j].selected) {
                        _arr.push(this.taskDetails.data[j]);
                    }
                }
                if (_arr.length == this.taskDetails.data.length) {
                    this.selectAll = true;
                } else {
                    this.selectAll = false;
                }
                this.selectedSendPersonnel = _arr;
            },
            // 下发人员至人脸设备
            fnSendPerson() {
                if (!this.selectedSendPersonnel.length) {
                    this.$message.warning('请选择需要下发至设备的人员。');
                    return;
                }
                this.needSendPersonnel = [];
                let _data = this.selectedSendPersonnel;
                for (let _key in _data) {
                    this.needSendPersonnel.push({
                        personnel_id: _data[_key].id,
                        name: _data[_key].name
                    });
                }
                if (this.selectedSendPersonnel.length != this.pageSize) {
                    this.showSelectFace = false;
                    this.fnGetaccessEqpt();
                    return;
                }
                this.$confirm('是否下发全部人员?', '提示', {
                        confirmButtonText: '下发当前页人员',
                        cancelButtonText: '下发全部人员'
                    })
                    .then(() => {
                        this.showSelectFace = false;
                        this.fnGetaccessEqpt();
                    })
                    .catch(() => {
                        request({
                                url: 'personnel/getAllPersonnel',
                                method: 'GET'
                            })
                            .then(res => {
                                this.needSendPersonnel = [];
                                for (let _key in res.data) {
                                    this.needSendPersonnel.push({
                                        personnel_id: res.data[_key].id,
                                        name: res.data[_key].name
                                    });
                                }
                                this.showSelectFace = false;
                                this.fnGetaccessEqpt(res.data[_key].id);
                            })
                            .catch(err => {
                                this.$message.error('获取全部人员失败');
                            });
                    });
            },
            // 获取人脸设备列表
            fnGetaccessEqpt() {
                request({
                        url: 'accessEqpt/get',
                        method: 'GET'
                    })
                    .then(res => {
                        this.showTaskDetails = false;
                        this.faceList = res.data.query;
                        var arr = [];
                        for (var i in this.faceList) {
                            if (this.eqptSN == this.faceList[i].sn) {
                                arr.push(this.faceList[i]);
                                this.faceList[i].selected = true;
                            } else {
                                this.faceList[i].selected = false;
                            }
                        }
                        if (arr.length > 0) {
                            this.selectAccess = arr;
                            this.showSelectFace = false;
                            this.fnSendPersonToAccess();
                        } else {
                            this.showSelectFace = false;
                            this.$message.error('该设备不在线！');
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 选择下发的设备
            // 全选
            fnSelectAllAccess() {
                let _arr = [];
                for (var i in this.faceList) {
                    let _select = this.fnSelectable(this.faceList[i], i);
                    if (_select) {
                        _arr.push(this.faceList[i]);
                        this.faceList[i].selected = true;
                    } else {
                        this.faceList[i].selected = false;
                    }
                }
                if (this.faceList.length != _arr.length) {
                    this.$message.error('不在线的设备不能选择！');
                }
                this.selectAccess = _arr;
            },
            // 单个选择
            fnHandleCheckedAccessChange(_index, _item) {
                let isSelect = this.fnSelectable(_item, _index);
                if (!isSelect) {
                    this.$message.error('此设备不在线！');
                    return;
                }
                for (let i = 0; i < this.faceList.length; i++) {
                    if (i == _index) {
                        this.faceList[i].selected = !this.faceList[i].selected;
                    }
                }
                let _arr = [];
                for (let j = 0; j < this.faceList.length; j++) {
                    if (this.faceList[j].selected) {
                        _arr.push(this.faceList[j]);
                    }
                }
                if (_arr.length == this.faceList.length) {
                    this.selectAllAccess = true;
                } else {
                    this.selectAllAccess = false;
                }
                this.selectAccess = _arr;
            },
            // 下发人员至人脸设备
            fnSendPersonToAccess() {
                if (!this.selectAccess.length) {
                    this.$message.warning('请选择需要下发的人脸设备');
                    return;
                }
                let _data = this.selectAccess;
                for (let i = 0; i < _data.length; i++) {
                    this.fnAddTask({
                            name: '下发人员至设备',
                            content: '下发人员至设备,设备SN:' + _data[i].sn
                        },
                        res => {
                            request({
                                    url: (APP.isTest ? APP.HOST.TEST.TASK_DELIVER : APP.HOST.OFFICIAL
                                        .TASK_DELIVER) + '/task/deliver/',
                                    method: 'POST',
                                    data: {
                                        eqptSN: this.selectAccess[i].sn,
                                        cmd: 'sendPerson',
                                        data: JSON.stringify(this.needSendPersonnel),
                                        company_name: this.userInfo.name,
                                        tid: res.tid
                                    }
                                })
                                .then(res => {
                                    this.$message.success(res.data);
                                    this.showSelectFace = false;
                                    this.$router.go(0);
                                })
                                .catch(err => {
                                    this.showErrorDown = true;
                                    this.$message.success(err.data);
                                });
                        }
                    );
                }
            },
            // 创建任务
            fnAddTask(_obj, _cb) {
                request({
                        url: 'task/add',
                        method: 'POST',
                        data: _obj
                    })
                    .then(res => {
                        _cb && _cb(res.data);
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 人员在线状态 判断数据是否可选
            fnSelectable(row, index) {
                if (this.fnOnlineStatusText(row.heartbeatTime).status) {
                    return true;
                } else {
                    return false;
                }
            },
            // 门禁设备在线状态
            fnOnlineStatusText(_heartbeatTime) {
                return APP.fnOnlineStatusText(_heartbeatTime);
            },
            // 表格错误信息高亮
            fnTableRowClassName(row, rowIndex) {
                if (row.row.state != APP.YES) {
                    return 'danger-row';
                }
            },
            // 查看任务详情
            fnShowDetails(_data) {
                if (!_data) return;
                if (_data.indexOf('System.Runtime') !== -1) return this.$message.warning('请联系技术人员处理!');
                _data = JSON.parse(_data);
                let _title = '任务编号: ' + _data.tid;
                let _errorArr = [];
                let _successArr = [];
                if (_data.data && typeof _data.data == 'object') {
                    this.eqptSN = _data.eqptSN;
                    for (let _key in _data.data) {
                        let _item = _data.data[_key];
                        if (_item.state == undefined) {
                            _successArr.push({
                                name: _item.name,
                                state: _item.state,
                                text: '下发失败'
                            });
                            this.isError = true;
                        } else if (_item.state == 1) {
                            _successArr.push({
                                name: _item.name,
                                state: _item.state,
                                text: '下发成功'
                            });
                            this.isError = false;
                        } else {
                            let _equipmentType = _data.eqptSN.length;
                            let _details = '';
                            switch (_equipmentType) {
                                case 20: // 012360-D3005B-4F4DEE
                                    _details = _item.details.indexOf('explain') !== -1 ? JSON.parse(_item.details)
                                        .explain : _item.details;
                                    break;
                                case 16: // 84E0F4226DD406B2
                                    if (_item.details.indexOf('result') == -1) {
                                        _details = _item.details;
                                        break;
                                    }
                                    _details = JSON.parse(JSON.parse(_item.details).result).msg;
                                    break;
                                case 17: // 1b36fe49-bdeeadc7
                                    if (_item.details.indexOf('Message:Undefined') !== -1) {
                                        _details = _item.details;
                                        break;
                                    }
                                    _details = _item.details.indexOf('explain') !== -1 ? JSON.parse(_item.details)
                                        .explain : _item.details;
                                    break;
                                default:
                                    _details = _item.details;
                                    break;
                            }
                            _errorArr.push({
                                id: _item.personnel_id,
                                name: _item.name,
                                state: _item.state,
                                text: '下发失败',
                                details: _details,
                                select: false
                            });
                            this.isError = true;
                        }
                    }
                    this.taskDetails.title = _title;
                    this.taskDetails.data = _errorArr.concat(_successArr);
                    this.showTaskDetails = true;
                } else {
                    this.$message.error(_data.data);
                }
            },
            // 处理详情json数据
            fnDetailsFormat(_data) {
                if (!_data) return '';
                if (_data.indexOf('System.Runtime') === -1) {
                    _data = JSON.parse(_data);
                    if (!_data) return;
                    let _str = '';
                    _str += '任务编号：' + _data.tid + ',执行时间：' + new Date(_data.time * 1000).Format('yyyy-MM-dd hh:mm:ss');
                    let _dataArr = [];
                    if (_data.data && _data.data.length) {
                        _data.data.forEach(_item => {
                            if (_item.state == 1) {
                                _dataArr.push('姓名：' + _item.name + '，下发成功');
                            } else {
                                _dataArr.push('姓名：' + _item.name + '，下发失败，失败原因:' + _item.details);
                            }
                        });
                    }
                    _str += '; ' + _dataArr.join(',');
                    return _str;
                } else {
                    return _data;
                }
            },
            // 搜索
            fnSearch(_isReset = true) {
                this.currentPage = _isReset ? APP.PAGE.SKIP_PAGE : this.currentPage;
                this.fnGetData({
                        page: this.currentPage,
                        size: this.pageSize,
                        name: this.searchName,
                        content: this.searchContent,
                        state: this.searchState
                    },
                    res => {
                        this.tableData = res.data.query;
                        this.pageTotal = res.data.count;
                    }
                );
            }
        }
    };
</script>

<style scoped lang="scss">
    @import '~@/styles/mixin.scss';

    .task_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .task {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .search_box {
        height: 32px;
        width: 1880px;
        margin-top: 24px;
        margin-left: 20px;
        @include flex-box(space-between, center, column);

        .box_line {
            width: 1880px;
            height: 32px;
            @include flex-box(flex-start, center);

            .line_input {
                min-width: 280px;
                height: 30px;
                margin-right: 10px;
                border-top-right-radius: 1px;
                border-bottom-right-radius: 1px;
                background-color: rgba(49, 88, 128, 0.4);
                @include flex-box(flex-start, center);

                .input_title {
                    width: 69px;
                    height: 30px;
                    font-size: 14px;
                    color: #9bf9fc;
                    border-radius: 2px;
                    background-color: rgba(155, 249, 252, 0.1);
                    @include flex-box(center, center);
                }

                .input_box {
                    width: 211px;
                    height: 30px;
                    line-height: 30px;
                    padding-left: 15px;
                    color: rgba(77, 180, 244, 0.7);
                    font-size: 12px;
                    border-radius: 2px;
                    outline: none;
                    background: transparent;
                    border: none;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }

                .select_box {
                    width: 211px;
                    height: 30px;
                    border-radius: 2px;
                }
            }
        }
    }

    .cont_list {
        margin-top: 29px;
        margin-left: 28px;
        width: 1864px;
        height: 691px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .list_title {
            width: 1864px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 126px;
                    margin: 0 4px 0 40px;
                }

                &:nth-child(2) {
                    width: 276px;
                    margin-right: 4px;
                }

                &:nth-child(3) {
                    width: 396px;
                    margin-right: 4px;
                }

                &:nth-child(4) {
                    width: 396px;
                    margin-right: 4px;
                }

                &:nth-child(5) {
                    width: 100px;
                    margin-right: 4px;
                }

                &:nth-child(6) {
                    width: 186px;
                    margin-right: 4px;
                }

                &:nth-child(7) {
                    width: 184px;
                    margin-right: 4px;
                }

                &:nth-child(8) {
                    width: 90px;
                    margin-right: 40px;
                }
            }
        }

        .list_boxes {
            width: 1864px;
            height: 643px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 1784px;
                    height: 70px;
                    margin: 7px 0 0 40px;
                    font-size: 16px;
                    color: #ffffff;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    &:hover {
                        background-color: rgba(49, 88, 128, 0.4);
                    }

                    .list_item {
                        height: 70px;
                        text-align: center;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 126px;
                            margin-right: 4px;
                        }

                        &:nth-child(2) {
                            width: 276px;
                            margin-right: 4px;
                        }

                        &:nth-child(3) {
                            width: 396px;
                            margin-right: 4px;
                        }

                        &:nth-child(4) {
                            width: 396px;
                            margin-right: 4px;
                        }

                        &:nth-child(5) {
                            width: 100px;
                            margin-right: 4px;
                        }

                        &:nth-child(6) {
                            width: 186px;
                            margin-right: 4px;
                        }

                        &:nth-child(7) {
                            width: 184px;
                            margin-right: 4px;
                        }

                        &:nth-child(8) {
                            width: 90px;
                        }

                        div {
                            @include flex-box(center, center);

                            .item_btn {
                                width: 69px;
                                height: 32px;
                                line-height: 32px;
                                margin: 0 2px;
                                font-size: 14px;
                                color: #ffffff;
                                border: none;
                                cursor: pointer;
                                background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                                background-size: 100% 100%;
                                @include flex-box(center, center);

                                span {
                                    margin-top: -2px;
                                }
                            }
                        }

                        span {
                            width: 100%;
                            cursor: pointer;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }

    .box_line {
        >>>.el-input__inner {
            width: 211px;
            height: 30px;
            border-radius: 2px;
            border: none;
            color: rgba(77, 180, 244, 0.7);
            background: transparent;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

        >>>.el-select {
            .el-input {
                .el-select__caret {
                    color: rgba(77, 180, 244, 0.7);
                }
            }
        }

        >>>.el-select-dropdown {
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(77, 180, 244, 1);
        }

        >>>.popper__arrow {
            border-bottom-color: rgba(77, 180, 244, 1) !important;
        }

        >>>.el-select-dropdown__item {
            color: rgba(77, 180, 244, 0.7);
        }

        >>>.el-select-dropdown__item:hover {
            color: #409eff;
        }

        >>>.el-select-dropdown__item.hover {
            color: #409eff;
        }

        >>>.el-input__icon {
            color: rgba(77, 180, 244, 0.7);
        }
    }

    .dialog_task,
    .dialog_choose {
        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            width: 910px;
            height: 630px;
            margin-top: 25vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }

        .tips {
            height: 30px;
            line-height: 30px;
            color: #ffba00;
            font-size: 14px;
        }

        .cont_list {
            width: 860px;
            height: 425px;
            color: #ffffff;
            font-size: 16px;
            border-radius: 10px;
            margin: 0;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 860px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 66px;
                        margin: 0 4px 0 30px;
                    }

                    &:nth-child(2) {
                        width: 206px;
                        margin-right: 4px;
                    }

                    &:nth-child(3) {
                        width: 206px;
                        margin-right: 4px;
                    }

                    &:nth-child(4) {
                        width: 310px;
                        margin-right: 30px;
                    }

                    .select {
                        width: 20px;
                        height: 20px;
                        border: 1px solid #65a6dd;
                        border-radius: 2px;
                        cursor: pointer;
                        @include prefixCss3(transition, border-color 0.2s);

                        &:hover {
                            border-color: #409eff;
                        }

                        &.active {
                            background-color: #409eff;
                            border-color: #409eff;

                            &::after {
                                content: '';
                                display: block;
                                width: 100%;
                                height: 100%;
                                @include set-bg-img('../../../assets/images/icon-yes.png');
                            }
                        }
                    }
                }
            }

            .list_boxes {
                width: 800px;
                height: 302px;
                margin-left: 30px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 800px;
                        height: 70px;
                        margin: 5px 0 0 0px;
                        border-bottom: 1px dashed #1d4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 66px;
                                margin-right: 4px;
                            }

                            &:nth-child(2) {
                                width: 206px;
                                margin-right: 4px;
                            }

                            &:nth-child(3) {
                                width: 206px;
                                margin-right: 4px;
                            }

                            &:nth-child(4) {
                                width: 310px;
                            }

                            span {
                                width: 100%;
                                cursor: pointer;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            .select {
                                width: 20px;
                                height: 20px;
                                border: 1px solid #65a6dd;
                                border-radius: 2px;
                                cursor: pointer;
                                @include prefixCss3(transition, border-color 0.2s);

                                &:hover {
                                    border-color: #409eff;
                                }

                                &.active {
                                    background-color: #409eff;
                                    border-color: #409eff;

                                    &::after {
                                        content: '';
                                        display: block;
                                        width: 100%;
                                        height: 100%;
                                        @include set-bg-img('../../../assets/images/icon-yes.png');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .dialog_choose {
        .cont_list {
            width: 860px;
            height: 425px;
            color: #ffffff;
            font-size: 16px;
            border-radius: 10px;
            margin: 0;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 860px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 60px;
                        margin: 0 4px 0 30px;
                    }

                    &:nth-child(2) {
                        width: 180px;
                        margin-right: 4px;
                    }

                    &:nth-child(3) {
                        width: 180px;
                        margin-right: 4px;
                    }

                    &:nth-child(4) {
                        width: 180px;
                        margin-right: 4px;
                    }

                    &:nth-child(5) {
                        width: 184px;
                        margin-right: 30px;
                    }

                    .select {
                        width: 20px;
                        height: 20px;
                        border: 1px solid #65a6dd;
                        border-radius: 2px;
                        cursor: pointer;
                        @include prefixCss3(transition, border-color 0.2s);

                        &:hover {
                            border-color: #409eff;
                        }

                        &.active {
                            background-color: #409eff;
                            border-color: #409eff;

                            &::after {
                                content: '';
                                display: block;
                                width: 100%;
                                height: 100%;
                                @include set-bg-img('../../../assets/images/icon-yes.png');
                            }
                        }
                    }
                }
            }

            .list_boxes {
                width: 800px;
                height: 302px;
                margin-left: 30px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 800px;
                        height: 70px;
                        margin: 5px 0 0 0px;
                        border-bottom: 1px dashed #1d4495;
                        @include flex-box(flex-start, center);

                        .list_item {
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 60px;
                                margin-right: 4px;
                            }

                            &:nth-child(2) {
                                width: 180px;
                                margin-right: 4px;
                            }

                            &:nth-child(3) {
                                width: 180px;
                                margin-right: 4px;
                            }

                            &:nth-child(4) {
                                width: 180px;
                                margin-right: 4px;
                            }

                            &:nth-child(5) {
                                width: 184px;
                            }

                            .select {
                                width: 20px;
                                height: 20px;
                                border: 1px solid #65a6dd;
                                border-radius: 2px;
                                cursor: pointer;
                                @include prefixCss3(transition, border-color 0.2s);

                                &:hover {
                                    border-color: #409eff;
                                }

                                &.active {
                                    background-color: #409eff;
                                    border-color: #409eff;

                                    &::after {
                                        content: '';
                                        display: block;
                                        width: 100%;
                                        height: 100%;
                                        @include set-bg-img('../../../assets/images/icon-yes.png');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Task/TaskDefault/index.vue